import crowbar03 from '../assets/images/crowbar03.jpg';

import TourDateTable from '../components/tourDateTable.tsx';
import { getEvents, type BandsintownEvent } from '../utils/bandsintown.server.ts'

import { type Route } from './+types/shows.ts'

export function meta({ loaderData, matches }: Route.MetaArgs) {
  const { events = [] } = loaderData as { events: BandsintownEvent[] }
  const rootMatch = (matches as any[]).find(m => m.id === 'root')
  const { origin, path } = rootMatch?.loaderData?.requestInfo ?? { origin: '', path: '' }
  const rootMeta = (rootMatch?.meta ?? []) as Array<Record<string, string>>
  const inherited = rootMeta.filter(
    m => !('title' in m) && !(m.name === 'description') && !(m.property === 'og:image') && !(m.property === 'og:url')
  )

  const eventSchema = events.map((event) => ({
    "@type": "MusicEvent",
    name: event.title || `Rohna at ${event.venue.name}`,
    startDate: event.datetime,
    ...(event.ends_at && { endDate: event.ends_at }),
    location: {
      "@type": "MusicVenue",
      name: event.venue.name,
      address: {
        "@type": "PostalAddress",
        ...(event.venue.street_address && { streetAddress: event.venue.street_address }),
        ...(event.venue.city && { addressLocality: event.venue.city }),
        ...(event.venue.region && { addressRegion: event.venue.region }),
        ...(event.venue.postal_code && { postalCode: event.venue.postal_code }),
        ...(event.venue.country && { addressCountry: event.venue.country }),
      },
      ...(event.venue.latitude && event.venue.longitude && {
        geo: {
          "@type": "GeoCoordinates",
          latitude: event.venue.latitude,
          longitude: event.venue.longitude,
        },
      }),
    },
    performer: {
      "@type": "MusicGroup",
      name: "Rohna",
    },
    url: event.url,
    ...(event.offers.length > 0 && {
      offers: event.offers.map((offer) => ({
        "@type": "Offer",
        url: offer.url,
        availability: event.sold_out
          ? "https://schema.org/SoldOut"
          : "https://schema.org/InStock",
        ...(event.free && { price: 0, priceCurrency: "USD" }),
      })),
    }),
  }))

  return [
    ...inherited,
    { title: "Rohna Tour Dates | Concert Tickets | Indie Rock Band" },
    {
      name: "description",
      content: "Get the latest Rohna tour dates and concert tickets! Don't miss this Indie Alternative Rock band live on stage. Find shows near you and experience their electrifying performances!",
    },
    { property: 'og:url', content: `${origin}${path}` },
    {
      property: "og:title",
      content: "Rohna",
    },
    {
      property: "og:site_name",
      content: "Rohna",
    },
    {
      property: "og:description",
      content: "Discover Rohna - Tampa, Florida's rising Indie Alternative Rock band! Catch them live at a venue or festival near you as they take on some of the most iconic stages across the country. Stream and download their music on all platforms!",
    },
    {
      property: "og:image",
      content: `${origin}${crowbar03}`,
    },
    {
      "script:ld+json": {
        "@context": "https://schema.org",
        "@graph": eventSchema,
      },
    },
  ];
}

export async function loader() {
  const events = await getEvents()
  return { events }
}

export default function Tour({ loaderData }: Route.ComponentProps) {
  const { events } = loaderData;

  return (
    <section className="bg-[url('../assets/images/duotoneStageBW.jpg')] bg-cover bg-center bg-no-repeat min-h-[calc(100svh-135px)] md:min-h-[calc(100svh-160px)] lg:min-h-[calc(100svh-171px)]">
      <div className="flex flex-col md:px-16 2xl:px-48 bg-linear-to-b from-black via-black/50 to-transparent">
        <h1 className="text-center py-8 md:py-16 text-5xl md:text-7xl font-extrabold uppercase">Tour Dates</h1>
        <p className="pb-4 self-center">our upcoming shows</p>
        <TourDateTable events={events} color={"white"}/>
      </div>
    </section>
  )
}